import platform from 'components/Trackers/platform'

export const ScreenViewedEvent = {
  feature: 'MOC Registration Funnel',
  event_description: 'Referral Reminder Screen Viewed',
  platform,
  object: 'Screen',
  action: 'Viewed',
  object_name: 'mocRegistrationFunnelReferralReminder',
  screen: 'mocRegistrationFunnelReferralReminder',
  screen_name: 'mocRegistrationFunnelReferralReminder',
}

export const NextButtonTappedEvent = ctaTitle => {
  return {
    feature: 'MOC Registration Funnel',
    event_description: 'Referral Reminder Next button tapped',
    platform,
    object: 'Button',
    action: 'Tapped',
    object_name: 'mocRegistrationFunnelReferralReminderNext',
    screen: 'mocRegistrationFunnelReferralReminder',
    screen_name: 'mocRegistrationFunnelReferralReminder',
    cta_tile: ctaTitle,
  }
}
